import React from 'react';

const MaintenanceBanner = ({ message = 'We are currently in maintenance. Bookings are temporarily unavailable. Please try again later.' }) => (
  <div className="maintenance-banner" role="status" aria-live="polite">
    <div className="maintenance-banner__inner">
      <div className="maintenance-banner__label">Maintenance</div>
      <div className="maintenance-banner__content">
        <p className="maintenance-banner__title">Bookings temporarily unavailable</p>
        <p className="maintenance-banner__message">{message}</p>
      </div>
    </div>
  </div>
);

export default MaintenanceBanner;
